import React from 'react';
import PropTypes from "prop-types";

const SectionHeader = ({title, classes}) => {
    
    return (
      <div className={`section-head ${!!classes ? classes : ''}`}>
        <span className="col-auto pr-1">{title}</span>
        <hr className="section-head__line col-auto"/>
      </div>
    );
}

SectionHeader.propTypes = {
    title: PropTypes.string.isRequired
}

SectionHeader.defaultProps = {
  title: 'عنوان خودکار'
};

export default SectionHeader;